import React, {useEffect} from 'react';
import ScrollToTop from 'react-scroll-to-top';

interface IScrollToTopExtended {
  top?: number;
  smooth?: boolean;
  svgPath?: string;
  viewBox?: string;
  component?: any;
  scrollOnRender?: any;
  scollOnChange?: any;
  noButton?: boolean;

  bottom?: number;
}

export const scrollToTop = (top = 0) => {
  window.scroll({top: top, behavior: "smooth"});
};

const scrollToElement = element => {
  const y = element.getBoundingClientRect().top + window.pageYOffset;
  scrollToTop(y);
};

const ScrollToTopExtended = ({noButton, scrollOnRender, scollOnChange, bottom, ...props}: IScrollToTopExtended) => {
  useEffect(() => {
    if (scrollOnRender !== undefined) {
      if (typeof scrollOnRender === 'string' && scrollOnRender.length > 0 && scrollOnRender.startsWith("#")) {
        const performScrollToElement = () => {
          const element = document.getElementById(scrollOnRender.slice(1));
          scrollToElement(element);
        };
        const pageOffset = window.pageYOffset;
        performScrollToElement();
        setTimeout(() => {
          /**
           * If page offset changed, it means some elements were added/removed dynamically,  just scroll again
           */
          if (pageOffset !== window.pageYOffset) {
            performScrollToElement();
          }
        }, 1000);
      } else {
        scrollToTop();
      }
    }
  }, [scrollOnRender, scollOnChange]);
  return noButton ? null : (
    <ScrollToTop style={{bottom: bottom, zIndex: 999999}} {...props}/>
  );
};

ScrollToTopExtended.defaultProps = {
  label: '',
  value: 0,
  noButton: true,
  bottom: 40,
};

export default React.memo(ScrollToTopExtended);
